import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearGroup } from "../../../Pages/Year group/IyearGroup";

export const EdityearGroupSlice = createSlice({
  name: "EdityearGroupSlice",
  initialState: {} as IReduxState<IYearGroup>,
  reducers: {
    EdityearGroup: (state, _: PayloadAction<IYearGroup>) => {
      state.isLoading = true;
    },
    successEdityearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEdityearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEdityearGroupResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EdityearGroup,
  failureEdityearGroup,
  successEdityearGroup,
  clearEdityearGroupResponse,
} = EdityearGroupSlice.actions;

export default EdityearGroupSlice.reducer;
